import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/hooks';
import { getVisibleProfileTabs } from './tabs';

export default function ProfilePage() {
    const profile = useAppSelector(store => store.profile);
    const navigate = useNavigate();

    useEffect(() => {
        const availableTab = getVisibleProfileTabs(profile)[0];
        if (availableTab) {
            navigate(availableTab.route, { replace: true });
        }
    }, [profile, navigate]);

    return <></>;{/*This form cannot be deleted. This intermediate form is needed to ensure that the breadcrumbs display correctly.*/}
}
